import React from 'react'
import { Col, Row } from 'reactstrap'

const StiCauses = () => {
  return (
    <div id='website-responsive' style={{ overflow:'hidden'}}>
        <div className='left-padding5rem1 right-padding5rem1 pb-md-5 pb-4 pt-2'>
            <div className=''>
                <div className='fs-ss-30 text-montserrat text-ss-primary fw-700'>
                    Causes of STIs
                </div>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pt-3'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black'>
                STIs can be caused by various organisms, including:
                </div>
            </div>

            <div className='pt-md-5 pt-4'>
                <Row className=''>
                    <Col md='12' lg='4' className='pe-md-5 pb-md-5'>
                        <div className='' style={{ }}>
                            <img src='sti-testing/Bacteria-icon-ULC-STI-Testing.png' alt='Sti Testing' height='110px' width='110px' />
                        </div>
                        <div className='py-2 ps-2'>
                            <div className='fs-ss-20 text-montserrat fw-700 text-ss-black'>
                                Bacteria
                            </div>
                        </div>

                        <div className='ps-2 pb-md-0 pb-5'>
                            <div className='fs-ss-14-3 text-montserrat fw-600 text-ss-black' style={{ textAlign:'justify'}}>
                            Bacterial STIs include chlamydia, gonorrhea, and syphilis. These infections can be spread through sexual intercourse or close genital contact with an infected person.
                            </div>
                        </div>
                    </Col>
                    <Col md='12' lg='4' className='pe-md-5 pb-md-5'>
                        <div className='' style={{ }}>
                            <img src='sti-testing/Viruses-icon-ULC-STI-Testing.png' alt='Sti Testing' height='110px' width='110px' />
                        </div>

                        <div className='ps-2 py-2'>
                            <div className='fs-ss-20 text-montserrat fw-700 text-ss-black'>
                                Viruses
                            </div>
                        </div>

                        <div className='ps-2 pb-md-0 pb-5'>
                            <div className='fs-ss-14-3 text-montserrat fw-600 text-ss-black' style={{ textAlign:'justify'}}>
                            Viral STIs include infections such as human papillomavirus (HPV), herpes simplex virus (HSV), human immunodeficiency virus (HIV), and hepatitis B and C. These viruses can be transmitted through sexual contact, including vaginal, anal, or oral sex, and contact with infected blood or other bodily fluids.
                            </div>
                        </div>

                    </Col>
                    <Col md='12' lg='4' className='pe-md-5 pb-md5'>
                        <div className='' style={{ }}>
                            <img src='sti-testing/Parasite-icon-ULC-STI-Testing.png' alt='' height='110px' width='110px' />
                        </div>
                        <div className='ps-2 py-2'>
                            <div className='fs-ss-20 text-montserrat fw-700 text-ss-black'>
                                Parasites
                            </div>
                        </div>

                        <div className='ps-2'>
                            <div className='fs-ss-14-3 text-montserrat fw-600 text-ss-black' style={{ textAlign:'justify'}}>
                            Parasitic STIs are less common but can still occur. One example is pubic lice (crabs), which can be transmitted through sexual contact or close personal contact with an infected person.
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  )
}

export default StiCauses